import { Component } from "@angular/core";
import { BaseEntity, BaseState } from "../entities/BaseEntities";
import { BasePageComponent } from "./BasePageComponent";
import { ServiceBagService } from "./ServiceBag";

@Component({ selector: 'app-null', template:'<div style="background-color:red">NULL COMPONENT</div><span>NULL COMPONENT</span>' })
export class NullComponent extends BasePageComponent<BaseEntity, BaseState>
{
    constructor(A: ServiceBagService) 
    {
        super(A, 'NullComponent', BaseEntity, BaseState);
    }
}
